import { useLenis } from "@/hooks/useLenis";
import SiteHeader from "@/components/SiteHeader";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Apartment from "@/components/Apartment";
import ComfortBand from "@/components/ComfortBand";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Distances from "@/components/Distances";
import BookingCta from "@/components/BookingCta";
import SiteFooter from "@/components/SiteFooter";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function Landing() {
  useLenis();

  return (
    <div data-testid="landing-page" className="relative min-h-screen bg-linen text-ink font-sans">
      <div className="grain-overlay" />
      <SiteHeader />
      <main>
        <Hero />
        <Marquee />
        <Apartment />
        <ComfortBand />
        <Gallery />
        <Reviews />
        <Distances />
        <BookingCta />
      </main>
      <SiteFooter />
      <FloatingWhatsApp />
    </div>
  );
}
